import { render, staticRenderFns } from "./gallery-viewer.vue?vue&type=template&id=3fa9fcf2&scoped=true"
import script from "./gallery-viewer.vue?vue&type=script&lang=js"
export * from "./gallery-viewer.vue?vue&type=script&lang=js"
import style0 from "./gallery-viewer.vue?vue&type=style&index=0&id=3fa9fcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa9fcf2",
  null
  
)

export default component.exports